var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "TcCancelAppointment fixed z-10 inset-0 overflow-y-auto",
      attrs: {
        "aria-labelledby": "modal-title",
        role: "dialog",
        "aria-modal": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        },
        [
          _c("div", {
            staticClass:
              "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "hidden sm:inline-block sm:align-middle sm:h-screen",
              attrs: { "aria-hidden": "true" }
            },
            [_vm._v("​")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "inline-block bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all align-middle max-w-lg w-full"
            },
            [
              _c("div", { staticClass: "bg-white px-4 py-10" }, [
                _c("div", { staticClass: "flex flex-col items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-orange-400"
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "h-12 w-12 text-white",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "currentColor",
                            viewBox: "0 0 24 24",
                            stroke: "none",
                            "aria-hidden": "true"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M 11.977 1.771 C 13.83 1.758 14.617 2.765 14.617 3.75 L 13.784 15.339 C 13.784 16.324 12.985 17.123 12 17.123 C 11.015 17.123 10.216 16.324 10.216 15.339 L 9.447 3.764 C 9.447 2.779 10.124 1.784 11.977 1.771 Z",
                              fill: "currentColor"
                            }
                          }),
                          _vm._v(" "),
                          _c("circle", {
                            attrs: {
                              fill: "currentColor",
                              cx: "12",
                              cy: "21.5",
                              r: "2.5"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 text-center" }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "text-2xl leading-6 font-medium text-gray-900",
                        attrs: { id: "modal-title" }
                      },
                      [
                        _vm._v(
                          "\n              ¿Estas seguro de cancelar tu cita?\n            "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mt-5 mb-3 w-10 mx-auto" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2" }, [
                      _c("div", { staticClass: "text-xl text-gray-500" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex justify-center items-center mx-auto mb-3"
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "h-6 w-6 mr-3",
                                style: {
                                  color: _vm.$root.delegationColor(
                                    _vm.appointment.delegation_id
                                  )
                                },
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24"
                                }
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "12",
                                    cy: "12",
                                    r: "12",
                                    fill: "currentColor"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("h4", [
                              _vm._v(_vm._s(_vm.appointment.delegation_name))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "Cita " +
                              _vm._s(
                                _vm.appointment.type == "phone_call"
                                  ? "Telefónica"
                                  : "Presencial"
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.appointment.reserved_at.toDate()))
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.appointment.reserved_at.toTime()))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "bg-gray-50 py-3 px-6 flex flex-row-reverse justify-center"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-400 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$parent.deleteAppointment(
                            _vm.appointment.id
                          )
                        }
                      }
                    },
                    [_vm._v("\n          Confirmar\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$parent.canceling = false
                        }
                      }
                    },
                    [_vm._v("\n          〈 Atrás\n        ")]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }